module.exports = __webpack_public_path__ + "static/media/fox_Victory.db6efe05.png";